<template>
  <div class="row">
    <loading
      class="custom-loading-overlay"
      :active="isLoading"
      :color="loadingColor"
      :isFullPage="true"
    ></loading>
    <div class="col-12" style="padding-left: 5px; padding-right: 5px">
      <div
        class="card card-style"
        style="background-color: white; margin-left: 0px; margin-right: 0px"
      >
        <div class="card-body">
          <h3 class="card-title">Cadastrar Paciente</h3>
          <div class="form-group">
            <label for="inputField" class="col-form-label"
              ><span class="required">*</span> Nome:</label
            >
            <div class="custom-input-container">
              <input
                type="text"
                v-model="perfil.nome_paciente"
                class="custom-input"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="inputField" class="col-form-label"
              ><span class="required">*</span> Data de Nascimento:</label
            >
            <div class="custom-input-container">
              <input
                autocomplete="new-password"
                type="date"
                id="Name"
                class="form-control custom-input"
                v-model="perfil.data_nascimento"
                placeholder=""
              />
            </div>
          </div>
          <!-- <div class="form-group">
                            <label class="col-form-label ">Sexo:</label>
                            <select class="form-control custom-input" v-model="perfil.sexo">
                                <option value="M">Masculino</option>
                                <option value="F">Feminino</option>
                            </select>
                        </div> -->
          <div class="form-group">
            <label for="Name"> <span class="required">*</span> Sexo: </label>
            <select
              class="form-select custom-input"
              type="select"
              v-model="perfil.sexo"
            >
              <option value="M">Masculino</option>
              <option value="F">Feminino</option>
            </select>
          </div>

          <div class="form-group">
            <label>Deficiências</label>
            <input
              type="text"
              class="form-control"
              v-model="perfil.deficiencia"
            />
          </div>
          <div class="form-group" v-if="perfil.deficiencia == 'SIM'">
            <label>Qual?</label>
            <input
              v-model="perfil.deficiencia_descricao"
              type="text"
              class="form-control"
            />
          </div>

          <div class="form-group">
            <label for="Name"><span class="required">*</span> CEP: </label>
            <input
              autocomplete="new-password"
              id="Name"
              v-model="perfil.cep"
              placeholder=""
              type="tel"
              class="form-control"
              v-on:keyup="buscar"
              v-mask="'99999-999'"
            />
          </div>

          <div class="form-group">
            <label for="Name"><span class="required">*</span> Endereço: </label>
            <input
              autocomplete="new-password"
              type="text"
              id="Name"
              class="form-control"
              v-model="perfil.endereco"
              placeholder=""
            />
          </div>

          <div class="form-group">
            <label for="Name"><span class="required">*</span> Número: </label>
            <input
              autocomplete="new-password"
              type="text"
              id="inputNumero"
              class="form-control"
              v-model="perfil.numero"
              placeholder=""
            />
          </div>

          <div class="form-group">
            <label for="Name"> Complemento: </label>
            <input
              autocomplete="new-password"
              type="text"
              id="Name"
              class="form-control"
              v-model="perfil.complemento"
              placeholder=""
            />
          </div>

          <div class="form-group">
            <label for="Name"><span class="required">*</span> Bairro: </label>
            <input
              autocomplete="new-password"
              type="text"
              id="Name"
              class="form-control"
              v-model="perfil.bairro"
              placeholder=""
            />
          </div>

          <div class="form-group">
            <label><span class="required">*</span> Estado </label>
            <v-select
              :options="ufs"
              :reduce="(ufs) => ufs.id"
              :label="'uf_nome'"
              v-model="perfil.estado_id"
              @input="getEstadoMunicipio"
              class="vselect"
            />
          </div>

          <div class="form-group">
            <label><span class="required">*</span> Município </label>
            <v-select
              :options="municipios"
              :reduce="(municipios) => municipios.id"
              :label="'municipio_nome'"
              v-model="perfil.municipio_id"
              class="vselect"
            />
          </div>

          <div class="form-group">
            <label for="Name"> Telefone: </label>
            <input
              autocomplete="new-password"
              type="tel"
              id="Name"
              class="form-control"
              v-model="perfil.telefone"
              placeholder=""
              v-mask="'(99) 99999-9999'"
            />
          </div>
          <div
            @click="remove()"
            class="form-group botao-apagar"
            v-if="perfil.paciente_id"
          >
            <div class="col-md-12">
              <button type="button" class="btn btn-apagar">APAGAR</button>
            </div>
          </div>
          <div @click="save()" class="form-group botao-salvar">
            <div class="col-md-12">
              <button type="button" class="btn">SALVAR</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import vSelect from "vue-select";
export default {
  data() {
    return {
      perfil: {
        nome_paciente: "",
        data_nascimento: "",
        sexo: "",
        municipio_id: "",
        estado_id: "",
        deficiencia_descricao: "",
        usuario_id: this.$store.state.usuario_id,
      },
      ufs: [],
      municipios: [],
      isLoading: false,
      loadingColor: "#5D9CEC",
      isDisabled: true,
    };
  },
  computed: {
    usuarioId() {
      const self = this;
      self.perfil.usuario_id = this.$store.state.usuario_id;
    },
  },
  methods: {
    /* changeStatusReceive(object) {
      const self = this;
      const api = self.$store.state.api + "teste";

      self.isLoading = true;

      self.$http
        .post(api, object)
        .then((response) => {})
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    }, */

    remove() {
      const self = this;
      self.isLoading = true;
      let api = self.$store.state.api + "paciente/" + self.perfil.paciente_id;

      const payload = {
        paciente_id: self.perfil.paciente_id,
      };

      axios
        .delete(api, payload)
        .then((response) => {
          self.$message("Sucesso", `Paciente removido com sucesso`, "success");
          self.isLoading = false;
          this.$router.push("/pacientes");
        })
        .catch((error) => {
          self.isLoading = false;
          self.$message("Erro", error.response.data, "error");
        });
    },

    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(self.perfil.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + self.perfil.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              return;
            }

            self.perfil.endereco = endereco.logradouro;
            self.perfil.bairro = endereco.bairro;
            self.perfil.complemento = endereco.complemento;

            let api =
              self.$store.state.api +
              "municipios?municipio_codigo=" +
              endereco.ibge.substring(0, endereco.ibge.length - 1);

            axios
              .get(api)
              .then((response) => {
                self.perfil.estado_id = response.data.data[0].uf_id;
                self.getEstadoMunicipio();
                self.perfil.municipio_id = response.data.data[0].municipio_id;
              })
              .catch((error) => {
                self.$message(null, error.response.data, "error");
              });

            $("#inputNumero").focus();
          }
        );
      }
    },

    save: function () {
      const self = this;
      self.isLoading = true;

      let api = self.$store.state.api + "criar-paciente";

      if (self.perfil.paciente_id) {
        api =
          self.$store.state.api + "update-paciente/" + self.perfil.paciente_id;
        self.perfil._method = "PUT";
      }

      axios
        .post(api, self.perfil)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.isLoading = false;
          this.$router.push("/pacientes");
        })
        .catch((error) => {
          self.isLoading = false;
          self.$message(null, error.response.data, "error");
        });
    },

    getUFs: function () {
      const self = this;
      let api =
        self.$store.state.api + "ufs?orderByAsc=uf_nome&paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.ufs = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getMunicipios: function () {
      const self = this;
      let api =
        self.$store.state.api +
        "municipios?orderByAsc=municipio_nome&paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.municipios = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getEstadoMunicipio() {
      const self = this;
      let api =
        self.$store.state.api +
        "municipios?orderByAsc=municipio_nome&paginated=false&uf_id=" +
        self.perfil.estado_id;

      axios
        .get(api)
        .then((response) => {
          self.municipios = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getPaciente(id) {
      const self = this;
      self.isLoading = true;

      self.perfil.usuario_id = Number(localStorage.getItem("usuario_id"));
      self.perfil.paciente_id = Number(id);

      const api = self.$store.state.api + "editar-paciente";
      axios
        .post(api, self.perfil)
        .then((response) => {
          self.perfil = response.data[0];
          self.isLoading = false;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.isLoading = false;
        });
    },
  },
  components: {
    Loading,
    vSelect,
  },
  props: {},
  mounted: function () {
    const self = this;

    self.getUFs();
    self.getMunicipios();

    let id = self.$route.params.id;

    if (id) {
      self.isLoading = true;
      self.getPaciente(id);
    }
    // $("#menu-main").removeClass("show");
    // $(".offcanvas-backdrop.show").removeClass("show");
    /* $(".theme-light").removeAttribute("style","overflow: hidden; padding-right: 0px;"); */
    // document.body.setAttribute("style", null);
    // self.isLoading = false;
  },
};
</script>
<style scoped>
/* CUSTOMIZACOES VUE LOADING */
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

/* CUSTOMIZACOES INPUTS */
.custom-input {
  border-radius: 0;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
}

.input-group > .form-control:focus {
  z-index: 3;
}

.custom-input-container {
  position: relative;
}

.custom-input {
  padding: 0.375rem 0.75rem;
  height: 2.714rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: 0 0.2rem 0.5rem rgba(0, 0, 0, 0.15);
  width: 100%;
}

.custom-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.botao-salvar {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
}

.btn {
  width: 100% !important;
  background-color: rgb(21, 72, 138) !important;
  margin: 0px 15px 18px -29px;
}

.form-group {
  margin-bottom: 9px !important;
}

.select-container {
  position: relative;
}

.select-container::after {
  content: "";
  position: absolute;
}

.botao-apagar {
  border-color: rgb(138 21 21);
  color: rgb(138 21 21);
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  border: 3px 3px 3px 3px !important;
}

.btn-apagar {
  width: 100% !important;
  margin: 25px 15px 0px 0px;
  background-color: rgb(138 21 21) !important;
  /* color: rgb(138 21 21); */
  border: 3px 3px 3px 3px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Pacientes/AdicionarPaciente.vue